<template>
    <div class="form-group" :class="model.size">
        <label class="font-weight-bold">{{ isEnVersion ? model.labelEn : model.label }}</label>
        <div aria-describedby="descriptionHelp">
            <toggle v-model="selectedValue"
                    @input="inputChanged"
                    @stringValueChanged="stringValueChanged"
                    :class="model.fieldCode"
                    :disabled="model.isReadOnly || details"></toggle>
        </div>
        <small id="descriptionHelp" class="form-text text-muted">{{ isEnVersion ? model.descriptionEn : model.description }}</small>
    </div>
</template>

<script>
    import Toggle from '@/components/toggle/Toggle';
    import { DynamicRegisterFieldValueModel, EditorComponentModel } from '../../models/models';
    import { mapGetters } from 'vuex';
    import { RegisterEventBus } from '@/buses/register-bus.js';

    export default {
        inject: ['$validator'],
        props: {
            model: EditorComponentModel,
            value: DynamicRegisterFieldValueModel,
            details: {
                type: Boolean,
                default: false
            },
            allowAnonymous: {
                type: Boolean,
                default: true
            },
            profileData: {
                type: Object,
                default() {
                    return null;
                }
            },
            isEvaluationPanel: {
                type: Boolean,
                default: false
            }
        },
        components: {
            Toggle
        },
        data() {
            return {
                selectedValue: this.model.fieldValue.booleanValue
                    ? this.model.fieldValue.booleanValue : this.model.booleanDefaultValue
            }
        },
        methods: {
            inputChanged(event) {
                this.model.fieldValue.booleanValue = event;
                this.$emit('input', this.model.fieldValue);
                RegisterEventBus.$emit('dynamic-field-change', event, event, this.model);
            },
            stringValueChanged(stringValue) {
                this.model.fieldValue.stringValue = stringValue;
            },
            fillProfileData(data) {
                if (!data) {
                    return;
                }

                // Todo
            }
        },
        mounted() {
            this.model.fieldValue.booleanValue = this.selectedValue;
            this.model.uid = this._uid;
            this.model.isEvaluationPanel = this.isEvaluationPanel;
        },
        computed: {
            ...mapGetters(['isEnVersion']),
        },
        watch: {
            profileData: {
                handler: function (newVal, oldVal) {
                    this.fillProfileData(newVal);
                },
                deep: true,
                immediate: true,
            },
        }
    }
</script>
